import { createSlice } from "@reduxjs/toolkit"


const initialState = {
  profileInfo: {
    name: "",
    phone: "",
    gender: "",
    dateOfBirth: "",
    email: "",
    profileImage: "",
    status: "",
  }
}


export const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    updateProfileInfo: (state, action) => {
      state.profileInfo = { ...state.profileInfo, ...action.payload };
    },
    resetProfileInfo: state => {
      state.profileInfo = initialState.profileInfo
    }
  }
});

export const { updateProfileInfo, resetProfileInfo } = profileSlice.actions;
export default profileSlice.reducer;